import { Component, OnInit, Input, Output, EventEmitter, inject, ViewChild, AfterViewInit } from '@angular/core'; // Asegúrate de importar AfterViewInit
import { FormsModule } from '@angular/forms';
import { CommonModule, formatDate } from '@angular/common';
import { NgbDatepickerModule, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { PlanificacionService } from '../../../../services/planificacion.service';
import { ModalComponent } from "../../../modal/modal.component";
import { I18n, CustomDatepickerI18n } from '../../../../clases/idioma-fecha';
import { SeleccionAspirantesComponent } from "./seleccion-aspirantes/seleccion-aspirantes.component";

@Component({
  selector: 'app-organizacion-seleccion',
  standalone: true,
  imports: [CommonModule, FormsModule, ModalComponent, NgbDatepickerModule, SeleccionAspirantesComponent, NgxMaskDirective],
  templateUrl: './organizacion-seleccion.component.html',
  styleUrl: './organizacion-seleccion.component.css',
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    provideNgxMask()
  ],
})
export class OrganizacionSeleccionComponent implements OnInit, AfterViewInit { // ⭐ Asegúrate de implementar AfterViewInit
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @Input() year?: number;
  @Input() user?: any;
  @Input() nom_ambito?: string;
  @Input() id_ambito?: string;
  @Output() vuelve = new EventEmitter<any>();
  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  errorMessage: string = '';
  rslOrganizacion: any[] = [];
  filteredOrganizacion: any[] = [];
  searchTermOrg: string = '';

  organizacionesSeleccionadas: any = [];

  isOrganizacion: boolean = false;

  mensaje_calulo!: string;
  color!: string;

  // ⭐ NUEVO: Propiedad para almacenar la suma total de cupos
  totalCuposSeleccionados: number = 0;

  private servicios = inject(PlanificacionService);

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.listarOrganizaciones(this.user.id_institucional.toString(), this.year!.toString(), this.id_ambito!, '0').subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        if ((rs.data.organizacion).length > 0) {
          this.rslOrganizacion = rs.data.organizacion.map((org: any) => ({
            ...org,
            isChecked: false, // Inicializa el checkbox como no marcado
            cupoValue: null // ⭐ NUEVO: Inicializa el valor del cupo a null o 0
          }));
          this.filteredOrganizacion = [...this.rslOrganizacion];
          this.calcularTotalCupos(); // ⭐ NUEVO: Calcular la suma inicial
        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'El ámbito seleccionado no tiene ninguna organización programada.';
          this.mdl.alerta();
        }
        console.log("Datos recibidos organizacion: ", this.rslOrganizacion);
      }
    });
  }

  buscar() {
    this.filteredOrganizacion = this.rslOrganizacion.filter((item: any) => {
      const identificacion = item.identificacion ? this.quitarAcentos(item.identificacion.toLowerCase()) : '';
      const nombre = item.organizacion ? this.quitarAcentos(item.organizacion.toLowerCase()) : '';
      const term = this.quitarAcentos(this.searchTermOrg.toLowerCase());

      return (
        identificacion.includes(term) ||
        nombre.includes(term)
      );
    });
    this.calcularTotalCupos(); // ⭐ NUEVO: Recalcular la suma después de filtrar
  }

  // ⭐ NUEVO: Método que se llama cuando un checkbox cambia
  onCheckboxChange() {
    this.calcularTotalCupos(); // Recalcular la suma
  }

  // ⭐ NUEVO: Método para calcular la suma total de cupos
  calcularTotalCupos() {
    let sum = 0;
    this.rslOrganizacion.forEach(org => {
      // Solo suma si el checkbox está marcado y el cupo tiene un valor numérico válido
      if (org.isChecked && org.cupoValue !== null && org.cupoValue !== undefined && !isNaN(Number(org.cupoValue))) {
        sum += Number(org.cupoValue);
      }
    });
    this.totalCuposSeleccionados = sum;
    if(this.totalCuposSeleccionados > 50){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = 'El valor del "Total Cupos Seleccionados" no puede exceder de 50.';
      this.mdl.alerta();
      return; // Detener el proceso si hay errores
    }
    console.log('Total Cupos Seleccionados:', this.totalCuposSeleccionados);
  }

  trackByOrgId(index: number, org: any): number { // ⭐ CAMBIO: Añadir 'index' como primer parámetro para trackBy
    return org.id_organizacion;
  }

  quitarAcentos(str: string): string {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  volver() {
    this.vuelve.emit({ value: false, validador: true, final: false });
  }

  volver_organizacion(valor: any){
    console.log('aaaaaa: ',valor)
    if(valor.validador){
      this.vuelve.emit({ value: false, validador: true, final: valor.final });
    }
    else{
      this.isOrganizacion = valor.validador;
    }

  }

  obtenerOrganizacionesSeleccionadas() {
    this.organizacionesSeleccionadas = this.rslOrganizacion.filter((org: any) => org.isChecked);

    // ⭐ OPCIONAL: Puedes añadir una validación aquí si el cupo es obligatorio al seleccionar
    const organizacionesConCupoInvalido = this.organizacionesSeleccionadas.filter((org: any) =>
      org.isChecked && (org.cupoValue === null || org.cupoValue === undefined || isNaN(Number(org.cupoValue)) || Number(org.cupoValue) <= 0)
    );

    //console.log('org:', organizacionesConCupoInvalido.length)
    //console.log('org_2:', organizacionesConCupoInvalido)
    //console.log('totla:', this.totalCuposSeleccionados)

    if (organizacionesConCupoInvalido.length > 0 || this.totalCuposSeleccionados == 0) {
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = 'Por favor, ingrese un cupo válido (mayor a 0) para todas las organizaciones seleccionadas.';
      this.mdl.alerta();
      return; // Detener el proceso si hay errores
    }
    else if(this.totalCuposSeleccionados > 50){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = 'El valor del "Total Cupos Seleccionados" no puede exceder de 50.';
      this.mdl.alerta();
      return; // Detener el proceso si hay errores
    }

    console.log('Organizaciones seleccionadas:', this.organizacionesSeleccionadas);
    this.isOrganizacion = true
  }
}
